import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { MainViewEntityActions } from '../../../features/main-view/data/store/main-view.store';

@Component({
  selector: 'rtr-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  @Output() public logOut: EventEmitter<void> = new EventEmitter();

  private ngOnDestroy$ = new Subject<void>();

  constructor(private store: Store) {}

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public closeSidebar(): void {
    this.store.dispatch(MainViewEntityActions.toggleSidebar());
  }
}
